<template>
  <div>
    <div class="style-home-page container justify-content-center p-0">
      <branch-information />

      <pull-to-refresh :refresh-function="handleRefresh">
        <list-header title="Popular Services" />
        <div class="style-content">
          <e-store-product-listing
            v-if="popularServiceSales"
            :productType=ProductType.SERVICE
            :items="popularServiceSales"
            :handleItem="viewItemDetail"
            :handleSeeAllButton="navToListingPage"
          />
          <list-header title="Popular Retail Products" />
          <e-store-product-listing
            v-if="popularRetailProducts"
            :productType=ProductType.RETAIL_PRODUCT
            :items="popularRetailProducts"
            :handleItem="viewItemDetail"
            :handleSeeAllButton="navToListingPage"
          />
          <list-header title="Popular Coupons" />
          <e-store-product-listing
            v-if="popularCoupons"
            :productType=ProductType.COUPON
            :items="popularCoupons"
            :handleItem="viewItemDetail"
            :handleSeeAllButton="navToListingPage"
            :cssClass="'pb-5'"
          />
          <div class="style-action-container fixed-bottom">
            <badge-button
              :quantity="cartsCount"
              iconClass="bi-cart-fill"
              redirectURL="/my-cart"/>
          </div>
      </div>
      </pull-to-refresh>
    </div>

    <toast-safari-installation v-if="showPWAInstallationToast" />
  </div>
</template>

<script>
import {
  defineAsyncComponent,
  markRaw
} from "vue";
import {
  mapGetters,
  mapActions
} from "vuex";
import store from "@/store";
import { ProductType } from "@/common/constant/ProductType";
import BadgeButton from "@/components/button/BadgeButton.vue";
import ListHeader from "@/components/ListHeader.vue";
import PullToRefresh from "@/components/PullToRefresh.vue";
import ToastSafariInstallation from "@/components/ToastSafariInstallation.vue";
import BranchInformation from "../components/BranchInformation.vue";
import EStoreProductListing from "../components/EStoreProductListing.vue";
import { openModal, closeModal } from "@/store/modal";
import { getToken } from "@/services/jwtService";
import { getItemLine } from "@/common/helpers/ProductHelper";

export default {
  name: "Estore",
  components: {
    BadgeButton,
    ListHeader,
    PullToRefresh,
    ToastSafariInstallation,
    BranchInformation,
    EStoreProductListing,
  },
   data() {
    return {
      ProductType,
    };
  },
  computed: {
    isLoggedIn() {
      return getToken() != null;
    },
    ...mapGetters([
      "showPWAInstallationToast",
      "popularServiceSales",
      "popularRetailProducts",
      "popularCoupons",
      "cartsCount",
    ]),
  },
  methods: {
    async handleRefresh() {
      // Fetch data parallely
      await Promise.all([
        (async () => await this.getInit())(),
        (async () => await this.getPopularServiceSales())(),
        (async () => await this.getPopularRetailProducts())(),
        (async () => await this.getPopularCoupons())(),
        (async () => await this.getCarts())(),
      ]);
    },
    navToListingPage(productType) {
      if (productType === ProductType.SERVICE) {
        this.$router.push("serviceSales");
      } else if (productType === ProductType.RETAIL_PRODUCT) {
        this.$router.push("retailProducts");
      } else if (productType === ProductType.COUPON) {
        this.$router.push("coupons");
      }
    },
    viewItemDetail(data) {
      let itemLine = this.getItemLine(data.type, data);
      openModal(
        {
          id: "expandableListItemDetailModal",
        },
        markRaw(defineAsyncComponent(() => import("@/components/ExpandableListItemDetail.vue"))),
        {
          image: data.image,
          processingTime: itemLine.formatProcessingTime,
          name: data.name,
          description: data.description,
          originalPrice: data.originalPrice,
          salePrice: data.salePrice,
          section: data.productSection?.name || '-',
          category: data.productCategory?.name || '-',
          promotion: data.promotion,
        },
        {},
        [
          {
            text: 'Add to cart',
            class: 'scss-blue-button',
            clickFn: async () => {
              if (!this.isLoggedIn) {
                this.$router.push("/login");
                closeModal();
                return;
              }

              store.commit("showLoading", true);
              await store.dispatch('postCart', {
                productId: data.id
              });
              closeModal();
              store.commit("showLoading", false);
            }
          },
          {
            text: 'Close',
            clickFn: () => {
              closeModal();
            }
          }
        ]
      );
    },
    ...mapActions([
      "getInit",
      "getPopularServiceSales",
      "getPopularRetailProducts",
      "getPopularCoupons",
      "getCarts",
    ]),
    getItemLine,
  },
}
</script>
<style lang="scss" scoped>
.style-home-page {
  margin-bottom: 70px;
}

.style-action-container {
  background-color: white;
  border: 1px solid $border-light-grey;
  bottom: 53.25px;
  margin: 0 auto 0 auto;
  max-width: 510px;
  padding-top: 5px;
  z-index: 5;
}
</style>
